import Axios from "../../api/Axios";
const BASE_URL = "SalesReport/";
const BASE_URL_SalesOrder = "SalesOrder/";


export const EndpointSalesReports = {
    DeliveryChallanExcel : "DeliveryChallanExcel",
    OpenSalesOrder : "OpenSalesOrder",
    TaxDetailRptDocwiseDownload : "TaxDetailRptDocwiseDownload",
    TaxDetailRptSalesTaxDownload : "TaxDetailRptSalesTaxDownload",
    TaxDetailRptDoctypeData : "TaxDetailRptDoctypeData",
    TaxDetailRptPopulateTax : "TaxDetailRptPopulateTax",
    GeSOPriv : "GeSOPriv"
};
// /api/SalesReport/TaxDetailRptDocwiseDownload
// /api/SalesReport/TaxDetailRptSalesTaxDownload
// /api/SalesReport/TaxDetailRptDoctypeData

// api/SalesReport/eInvoicingDataDownld
// /api/SalesReport/TaxDetailRptPopulateTax
export const createAPIEndpointSalesReports= () => {
    return {get:(Endpoint)=>Axios.get(BASE_URL+Endpoint)};
};
export const createAPIEndpointSalesOrder= () => {
    return {get:(Endpoint)=>Axios.get(BASE_URL_SalesOrder+Endpoint)};
};